import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Sparkles } from 'lucide-react';
import { templeInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0f2847] border-t border-sky-400/25 text-stone-200"
    >
      <div className="absolute top-0 left-1/2 -translate-x-1/2 h-px w-40 bg-gradient-to-r from-transparent via-amber-600/70 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/7npgfzob_AL%20LOGO.png"
                alt="Logo"
                className="h-12 w-auto"
              />
            </div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-sky-300/90 mb-2">
              Theravāda Tradition
            </div>
            <h3 className="font-serif-display text-2xl text-white mb-3">{templeInfo.name}</h3>
            <p className="text-sm text-stone-300 leading-relaxed">
              A sanctuary for meditation, wisdom and the unfolding of the Dhamma in Alabama.
            </p>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-sky-300/90 mb-5">Explore</div>
            <ul className="space-y-3">
              {[
                { to: '/about', label: 'About Us' },
                { to: '/programs', label: 'Programs' },
                { to: '/events', label: 'Events' },
                { to: '/dana-schedule', label: 'Daily Dāna' },
                { to: '/teachings', label: 'Teachings' },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-stone-200 hover:text-sky-300 transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-sky-300/90 mb-5">Resources</div>
            <ul className="space-y-3">
              <li><Link to="/buddha-life" className="text-sm text-stone-200 hover:text-sky-300 transition-colors">Life of Buddha</Link></li>
              <li><Link to="/gallery" className="text-sm text-stone-200 hover:text-sky-300 transition-colors">Gallery</Link></li>
              <li><Link to="/donate" className="text-sm text-stone-200 hover:text-sky-300 transition-colors">Make a Donation</Link></li>
              <li><Link to="/contact" className="text-sm text-stone-200 hover:text-sky-300 transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-sky-300/90 mb-5">Visit</div>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Phone size={15} className="text-sky-300 mt-0.5 flex-shrink-0" />
                <div className="text-stone-200">
                  <a href={`tel:${templeInfo.phone}`} className="block hover:text-sky-300 transition-colors">{templeInfo.phone}</a>
                  <a href={`tel:${templeInfo.phone2}`} className="block hover:text-sky-300 transition-colors">{templeInfo.phone2}</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={15} className="text-sky-300 mt-0.5 flex-shrink-0" />
                <a href={`mailto:${templeInfo.email}`} className="text-stone-200 hover:text-sky-300 transition-colors break-all">{templeInfo.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={15} className="text-sky-300 mt-0.5 flex-shrink-0" />
                <span className="text-stone-200 leading-relaxed">{templeInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-sky-400/25 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-stone-400 tracking-wide">© {currentYear} {templeInfo.name}. All rights reserved.</p>
          <div className="flex items-center gap-2 text-xs text-sky-300/90">
            <Sparkles size={12} />
            <span className="tracking-[0.25em] uppercase">May all beings be happy</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
